// removed by extract-text-webpack-plugin
module.exports = {"projectElement":"BaseComponent-cssmodule-projectElement-36WeJ"};


//////////////////
// WEBPACK FOOTER
// ./components/CommonSet/BaseComponent.cssmodule.less
// module id = 633
// module chunks = 0